import dayjs from 'dayjs';
import { IQuestion } from 'app/shared/model/question.model';

export interface IQuestionMentorFeedback {
  id?: number;
  meetingId?: number | null;
  menteeId?: string | null;
  mentorId?: string | null;
  feedBack?: string | null;
  createdDate?: string | null;
  updatedDate?: string | null;
  isShareFeedBack?: boolean | null;
  question?: IQuestion | null;
}

export const defaultValue: Readonly<IQuestionMentorFeedback> = {
  isShareFeedBack: false,
};
